import React from 'react'
import BaseIcon from 'react-icon-base'

const MO = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <title>MO</title>
    <defs>
      <rect id="a" width="21" height="15" rx="2" />
      <rect id="c" width="20" height="14" x=".5" y=".5" rx="2" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#00297B" xlinkHref="#a" />
      <g mask="url(#b)">
        <g fillRule="nonzero">
          <path fill="#C4272F" d="M0 0h20.861v14.901H0z" />
          <path fill="#015197" d="M7.954 0h5.954v14.901H7.954z" />
        </g>
        <g transform="translate(2.25 2.95)">
          <circle cx="2.276" cy="3.001" r="1.138" fill="#F9CF02" fillRule="nonzero" />
          <circle cx="2.276" cy="2.483" r="1.242" fill="#C4272F" fillRule="nonzero" />
          <circle cx="2.276" cy="2.69" r="1" fill="#F9CF02" fillRule="nonzero" />
          <path
            fill="#F9CF02"
            fillRule="nonzero"
            d="M1.76 1.138a.517.517 0 0 0 1.034 0c0-.207-.13-.233-.13-.31 0-.078.078-.181-.077-.31.077.129-.052.155-.052.284 0 .13.052.13.052.233a.104.104 0 0 1-.207 0c0-.104.103-.207.103-.362 0-.156-.026-.207-.103-.337C2.302.207 2.173.103 2.276 0 2.121.052 2.2.259 2.2.388c0 .13-.104.207-.104.362s.078.181.078.285a.104.104 0 0 1-.207 0c0-.104.052-.104.052-.233 0-.13-.13-.155-.052-.285-.155.13-.078.233-.078.31 0 .078-.129.104-.129.311zM0 4.346h1.035v4.967H0zM3.518 4.346h1.035v4.967H3.518zM1.242 5.174h2.07v1h-2.07zM1.242 8.071h2.07v1h-2.07zM1.242 4.346l1.034.62 1.035-.62z"
          />
          <path fill="#F9CF02" fillRule="nonzero" d="M1.242 8.692l1.034.62 1.035-.62z" />
          <circle cx="2.276" cy="6.829" r="1.097" fill="#F9CF02" fillRule="nonzero" stroke="#C4272F" strokeWidth=".5" />
          <path stroke="#C4272F" strokeWidth=".5" d="M2.276 5.733a.548.548 0 1 1 0 1.096.548.548 0 1 0 0 1.097" />
          <circle cx="2.276" cy="6.281" r="1" fill="#C4272F" fillRule="nonzero" />
          <circle cx="2.276" cy="7.378" r="1" fill="#C4272F" fillRule="nonzero" />
        </g>
      </g>
      <use stroke="#2F343A" strokeOpacity=".157" xlinkHref="#c" />
    </g>
  </BaseIcon>
)

export default MO
